import { Typography } from "#components/primitive/typography";
import classNames from "classnames";
import * as React from "react";
import s from "./default-layout.module.scss";

interface DefaultLayoutProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
	title?: React.ReactNode;
	subtitle?: React.ReactNode;
	description?: React.ReactNode;
	actions?: React.ReactNode;
	headerProps?: React.HTMLAttributes<HTMLDivElement>;
	actionsProps?: React.HTMLAttributes<HTMLDivElement>;
}

export function DefaultLayout({
	children,
	title,
	subtitle,
	description,
	actions,
	headerProps,
	actionsProps,
	className,
	...props
}: DefaultLayoutProps) {
	return (
		<div className={classNames(s.container, className)} {...props}>
			<div className={s.header} {...headerProps}>
				<div>
					{title && (
						<Typography type="heading" variant="v2">
							{title}
						</Typography>
					)}
					{subtitle && (
						<Typography type="paragraph" variant="v2" className={s.subtitle}>
							{subtitle}
						</Typography>
					)}
				</div>

				<div {...actionsProps}>{actions}</div>
			</div>

			{description && (
				<Typography type="paragraph" variant="v3" className={s.paragraph}>
					{description}
				</Typography>
			)}

			{children}
		</div>
	);
}
